(function () {
  if (!document.body.classList.contains('template-index')) return;

  const wrapper = document.querySelector('.header-wrapper--home');
  const hero = document.querySelector('.hero-strand-banner');
  if (!wrapper || !hero) return;

  const getThreshold = () => {
    const heroLogo = hero.querySelector('.hero-strand__logo--center');
    if (heroLogo) {
      const rect = heroLogo.getBoundingClientRect();
      return rect.bottom + window.scrollY - wrapper.offsetHeight - 12;
    }
    return hero.offsetTop + hero.offsetHeight * 0.25;
  };

  let scheduled = false;

  const update = () => {
    scheduled = false;
    const scrolled = window.scrollY > getThreshold();
    wrapper.classList.toggle('is-scrolled', scrolled);
    document.documentElement.classList.toggle('sval-home-scrolled', scrolled);
  };

  const onScroll = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
